import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../components/HeaderTitle'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import swal from 'sweetalert'
import moment from 'moment'
function Labs() {
    const hours = []
    for (let i = 0; i < 24; i++) {
        if (i < 10) {
            hours.push(`0${i}:00:00`)
        }
        else {
            hours.push(`${i}:00:00`)
        }
    }

    const { token } = useSelector(state => state.auth)

    const labUpdateForm = useForm()

    const labUpdateSubmit = (data) => {
        console.log("labupdatesubmit", data)

        // data.openTime last 3 characters are :00 so we need to remove them
        data.openTime = data.openTime.slice(0, -3)
        data.closeTime = data.closeTime.slice(0, -3)

        axios.put(`${process.env.REACT_APP_SERVICE_URL}/lab`, {
            id: data.id,
            labName: data.labName,
            address: data.address,
            openTime: data.openTime,
            closeTime: data.closeTime,
            sundayOpen: data.sundayOpen,
            numberOfTestPerHour: parseInt(data.numberOfTestPerHour)
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                console.log(response)
                swal('Başarılı', 'Laboratuvar bilgileri güncellendi', 'success')
                getLabInfo()
            })
            .catch(error => {
                console.log(error)
                swal('Hata', 'Bir hata oluştu', 'error')
            })

    }


    const getLabInfo = () => {

        axios.get(`${process.env.REACT_APP_SERVICE_URL}/lab`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                console.log("getLabinfo", response.data)
                labUpdateForm.setValue('id', response.data.id)
                labUpdateForm.setValue('labName', response.data.labName)
                labUpdateForm.setValue('address', response.data.address)
                labUpdateForm.setValue('openTime', response.data.openTime)
                labUpdateForm.setValue('closeTime', response.data.closeTime)
                labUpdateForm.setValue('sundayOpen', response.data.sundayOpen)
                labUpdateForm.setValue('numberOfTestPerHour', response.data.numberOfTestPerHour)

            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        getLabInfo()
    }, [])
    return (
        <div className='container-fluid'>
            <HeaderTitle title='Labs' description={'This is a page for labs'} />

            <div className='row'>
                <div className='col-md-4 col-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <form className='my-3' onSubmit={labUpdateForm.handleSubmit(labUpdateSubmit)}>
                                <div className='mb-3'>
                                    <label className='form-label'>Laboratuvar İsmi</label>
                                    <input type='text' className='form-control' {...labUpdateForm.register('labName')} />

                                </div>
                                <div className='mb-3'>
                                    <label className='form-label'>Adres</label>
                                    <textarea className='form-control' {...labUpdateForm.register('address')} />

                                </div>
                                <div className='mb-3'>
                                    <label className='form-label'>Başlangıç Saati</label>
                                    <select
                                        className='form-select'
                                        name='openTime'
                                        {
                                        ...labUpdateForm.register('openTime')
                                        }>
                                        {
                                            hours.map((hour, index) => {
                                                return <option key={index} value={hour}>{hour}</option>
                                            })

                                        }
                                    </select>
                                </div>

                                <div className='mb-3'>
                                    <label className='form-label'>Bitiş Saati</label>
                                    <select
                                        className='form-select'
                                        name='closeTime'
                                        {
                                        ...labUpdateForm.register('closeTime')
                                        }>
                                        {
                                            hours.map((hour, index) => {
                                                return <option key={index} value={hour}>{hour}</option>
                                            })

                                        }
                                    </select>
                                </div>

                                <div className='mb-3'>
                                    <label className='form-label'>Pazar Günü</label>
                                    <select className='form-select' name='sundayOpen' {...labUpdateForm.register('sundayOpen')}>
                                        <option value={true}>Açık</option>
                                        <option value={false}>Kapalı</option>
                                    </select>
                                </div>

                                <div className='mb-3'>
                                    <label className='form-label'>Saat Aralığı (Kaç İş Alınacak)</label>
                                    <input type='number' className='form-control' name='numberOfTestPerHour' {...labUpdateForm.register('numberOfTestPerHour')} />
                                </div>

                                <div className='mb-3'>
                                    <input type='hidden' {...labUpdateForm.register('id')} />
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default Labs